import React, { useEffect, useState } from "react";
import AutomatedDocumentTableCustomFilterZone from "../components/AutomatedDocumentTableCustomFilterZone";
import { withNamespaces } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Form, Col, Button, Accordion } from "react-bootstrap";
import { findIflowTasksByFilters } from "~/store/ducks/tasks/actionTypes";
import { BPM_MIDDLEWARE } from "~/utils/constants";
import Categories from "~/components/Tasks/Categories";

import DateTimePicker from "react-datetime-picker";
import { subDays } from "date-fns";
import "~/assets/css/icons.css";

import { useAccordionToggle } from "react-bootstrap/AccordionToggle";

const AutomatedDocumentTableFilters = (props) => {
  const { forceFiltersReset, setForceFiltersReset, t, onSearch, onReset } =
    props;

  const [startAt, setStartAt] = useState(undefined);
  const [endAt, setEndAt] = useState(undefined);
  const [endPaymentAt, setEndPaymentAt] = useState(undefined);
  const [startPaymentAt, setStartPaymentAt] = useState(undefined);
  const [fornecedor, setFornecedor] = useState(undefined);
  const [auxFornecedor, setAuxFornecedor] = useState(undefined);
  const [approvedRadioValue, setApprovedRadioValue] = useState("0");
  const [statusRadioValue, setStatusRadioValue] = useState(undefined);
  const [dateRadioValue, setDateRadioValue] = useState(undefined);
  const [paymentDateDefined, setPaymentDateDefined] = useState(false);
  const [checkSwitch, setCheckSwitch] = useState(false);

  useEffect(() => {
    if (forceFiltersReset) {
      handleFornecedor(" ");
      setStartAt(undefined);
      setEndAt(undefined);
      setStartPaymentAt(undefined);
      setEndPaymentAt(undefined);
      setPaymentDateDefined(false);
      setApprovedRadioValue("0");
      setCheckSwitch(false);
    }
    setForceFiltersReset(false);
  }, [forceFiltersReset]);

  const handleStartAt = (date) => {
    setStartAt(date);
  };

  const handleStartPaymentAt = (date) => {
    setStartPaymentAt(date);
  };

  const handleEndAt = (date) => {
    setEndAt(date);
  };

  const handleEndPaymentAt = (date) => {
    setEndPaymentAt(date);
  };

  const handleFornecedor = (fornecedor) => {
    setFornecedor(fornecedor);
  };

  const handleApplySearchTable = () => {
    let obj = {
      fornecedor: fornecedor,
      dataFaturaIncial: startAt,
      dataFaturaFinal: endAt,
      dataPagamentoInicial: startPaymentAt,
      dataPagamentoFinal: endPaymentAt,
      approvedRadioValue: approvedRadioValue,
      statusRadioValue: statusRadioValue,
      dateRadioValue: dateRadioValue,
      isPaid: paymentDateDefined,
    };
    onSearch(obj);
  };

  const handleApplyResetTable = () => {
    onReset();
  };

  return (
    <>
      <AutomatedDocumentTableCustomFilterZone
        startAt={startAt}
        endAt={endAt}
        startPaymentAt={startPaymentAt}
        endPaymentAt={endPaymentAt}
        handleStartAt={handleStartAt}
        handleStartPaymentAt={handleStartPaymentAt}
        handleEndPaymentAt={handleEndPaymentAt}
        handleEndAt={handleEndAt}
        handleFornecedor={handleFornecedor}
        fornecedor={fornecedor}
        approvedRadioValue={approvedRadioValue}
        setApprovedRadioValue={setApprovedRadioValue}
        dateRadioValue={dateRadioValue}
        setDateRadioValue={setDateRadioValue}
        setPaymentDateDefined={setPaymentDateDefined}
        forceFiltersReset={forceFiltersReset}
        checkSwitch={checkSwitch}
        setCheckSwitch={setCheckSwitch}
      />
      <br />
      <div className="dataCapture_groupButtons">
        <Button className="card-button" onClick={handleApplySearchTable}>
          {t("general.search")}
        </Button>
        <Button
          className="card-button"
          onClick={handleApplyResetTable}
          style={{ marginLeft: "15px" }}
        >
          Reset
        </Button>
      </div>
    </>
  );
};
export default withNamespaces()(AutomatedDocumentTableFilters);
